import React from 'react';
import Helmet from 'react-helmet';
import { Link } from 'react-router-dom';
import { lang } from '../lang_eula';
import renderHTML from 'react-render-html';
const Eula = () => (
  /**
   * This is just a sample EULA content.
   */

  <div className="main-container -pages">
    <Helmet>
      <title>{process.env.REACT_APP_NAME} - EULA</title>
      <meta name="description" content={lang.description} />
    </Helmet>

    <h1>{lang.eula}</h1>

    <p>{lang.eula_head_sub1}</p>

    <p>{lang.eula_head_sub2}</p>

    <p>{lang.eula_head_sub3}</p>

    <h2>{lang.eula_software_product}</h2>

    <p>{lang.eula_software_product_def}</p>

    <h3>{lang.eula_software1}</h3>

    <p>{lang.eula_software1_content}</p>

    <h3>{lang.eula_software2}</h3>

    <p>{lang.eula_software2_content}</p>

    <h4>{lang.eula_update}</h4>

    <p>{lang.eula_update_content}</p>

    <h4>{lang.eula_for_user18}</h4>

    <p>{lang.eula_for_user18_content}</p>

    <h4>{lang.eula_separation}</h4>

    <p>{lang.eula_separation_content}</p>

    <h4>{lang.eula_sofware_transfer}</h4>

    <p>{lang.eula_sofware_transfer_content}</p>

    <h4>{lang.eula_termination}</h4>

    <p>{lang.eula_termination_content}</p>

    <h2>{lang.eula_copyright}</h2>

    <h3>{lang.eula_sofware_transfer}</h3>

    <p>{lang.eula_copyright_content}</p>

    <h2>{lang.eula_limited}</h2>

    <h3>{lang.eula_no_warranty}</h3>

    <p>{lang.eula_no_warranty_content}</p>

    <h3>{lang.eula_no_liability}</h3>

    <p>{lang.eula_no_liability_content}</p>

    <h2>{lang.eula_support}</h2>

    <p>{renderHTML(lang.eula_support_content)}</p>
  </div>
);

export default Eula;



// WEBPACK FOOTER //
// ./src/pages/Eula.js